import { NetworkContext } from '@contexts/NetworkContext'
import { useContext } from 'react'

export const useNetwork = () => {
  const context = useContext(NetworkContext)

  if (!context) {
    throw new Error('useNetwork must be used within a NetworkProvider')
  }

  return context
}

export type UseNetworkReturn = ReturnType<typeof useNetwork>
